import enUS from './en-us';
import nl from './nl';

export default {
  'en-us': enUS,
  nl: nl
};
